(function () {
  angular.module('MktzapApp.Factories')
    .factory('PermissionService', PermissionService);

  PermissionService.$inject = ['$resource'];

  function PermissionService ($resource) {
    return $resource(apiUrl + '/user-permissions', {}, {
      get: { method: 'GET', params: {}, isArray: true },
      set: { method: 'POST', params: {}, isArray: false }
    });
  }
})();
